import Main from "@/layout/main.vue";
import Blank from "@/layout/blank.vue";
const routes = [
    {
        path: "/shop",
        name: "shop",
        meta: { title: "商城" },
        redirect: "/shop/lists",
        component: Main,
        children: [
            {
                path: "/shop/lists",
                name: "lists",
                meta: {
                    title: "商城管理",
                    parentPath: "/shop",
                    icon: "icon_ziti_store",
                    permission: ["view"],
                },
                component: Blank,
                redirect: "/shop/lists",
                children: [
                    {
                        path: "/shop/lists",
                        name: "shop_lists",
                        meta: {
                            title: "商城列表",
                            parentPath: "/shop",
                            permission: ["view"],
                        },
                        component: () => import("@/views/shop/shop/lists.vue"),
                    },
                    {
                        path: "/shop/lists_detail",
                        name: "lists_detail",
                        meta: {
                            hidden: true,
                            title: "商城信息",
                            parentPath: "/shop",
                            prevPath: "/shop/lists",
                            permission: ["view"],
                        },
                        component: () =>
                            import("@/views/shop/shop/lists_edit.vue"),
                    },
                    {
                        path: "/shop/modify_account",
                        name: "modify_account",
                        meta: {
                            hidden: true,
                            title: "修改超级管理员账号",
                            parentPath: "/shop",
                            prevPath: "/shop/lists",
                            permission: ["view"],
                        },
                        component: () =>
                            import("@/views/shop/shop/modify_account.vue"),
                    },
                    {
                        path: "/shop/package_record",
                        name: "package_record",
                        meta: {
                            hidden: true,
                            title: "套餐记录",
                            parentPath: "/shop",
                            prevPath: "/shop/lists",
                            permission: ["view"],
                        },
                        component: () =>
                            import("@/views/shop/shop/package_record.vue"),
                    },
                ],
            },
            {
                path: "/shop/set_meal",
                name: "set_meal",
                meta: {
                    title: "套餐管理",
                    parentPath: "/shop",
                    icon: "icon_order_guanli",
                    permission: ["view"],
                },
                component: Blank,
                redirect: "/shop/set_meal",
                children: [
                    {
                        path: "/shop/set_meal",
                        name: "set_meal",
                        meta: {
                            title: "套餐列表",
                            parentPath: "/shop",
                            permission: ["view"],
                        },
                        component: () =>
                            import("@/views/shop/set_meal/lists.vue"),
                    },
                    {
                        path: "/shop/set_meal_edit",
                        name: "set_meal_edit",
                        meta: {
                            hidden: true,
                            title: "商城套餐",
                            parentPath: "/shop",
                            prevPath: "/shop/set_meal",
                            permission: ["view"],
                        },
                        component: () =>
                            import("@/views/shop/set_meal/edit.vue"),
                    },
                ],
            },
            {
                path: "/shop/order_meal",
                name: "order_meal",
                meta: {
                    title: "订单套餐",
                    parentPath: "/shop",
                    icon: "icon_order_guanli",
                    permission: ["view"],
                },
                component: Blank,
                redirect: "/shop/order_meal",
                children: [
                    {
                        path: "/shop/order_meal",
                        name: "set_meal",
                        meta: {
                            title: "套餐列表",
                            parentPath: "/shop",
                            permission: ["view"],
                        },
                        component: () =>
                            import("@/views/shop/order_meal/lists.vue"),
                    },
                    {
                        path: "/shop/order_meal/use_record",
                        name: "shop_order_meal_use_record",
                        meta: {
                            title: "使用记录",
                            parentPath: "/shop",
                            permission: ["view"],
                        },
                        component: () =>
                            import("@/views/shop/order_meal/use_record.vue"),
                    },
                ],
            },
            {
                path: "/shop/withdraw",
                name: "shop_withdraw",
                meta: {
                    title: "提现管理",
                    parentPath: "/shop",
                    icon: "icon_order_guanli",
                    permission: ["view"],
                },
                component: Blank,
                redirect: "/shop/withdraw",
                children: [
                    {
                        path: "/shop/withdraw",
                        name: "withdraw_list",
                        meta: {
                            title: "提现列表",
                            parentPath: "/shop",
                            permission: ["view"],
                        },
                        component: () =>
                            import("@/views/shop/withdraw/lists.vue"),
                    },
                ],
            }, {
                path: "/shop/auth",
                name: "shop_auth",
                meta: {
                    title: "授权列表",
                    parentPath: "/shop",
                    icon: "icon_order_guanli",
                    permission: ["view"],
                },
                component: Blank,
                redirect: "/shop/auth",
                children: [
                    {
                        path: "/shop/auth",
                        name: "auth_list",
                        meta: {
                            title: "授权列表",
                            parentPath: "/shop",
                            permission: ["view"],
                        },
                        component: () =>
                            import("@/views/shop/auth-list.vue"),

                    },
                ],
            },
            {
                path: "/shop/distribution/distribution_list",
                name: "shop_distribution",
                meta: {
                    title: "分销商管理",
                    parentPath: "/shop/distribution/distribution_list",
                    icon: "icon_order_guanli",
                    permission: ["view"],
                },
                component: Blank,
                redirect: "/shop/distribution/distribution_list",
                children: [
                    {
                        path: "/shop/distribution/distribution_list",
                        name: "shop_distribution_list",
                        meta: {
                            title: "分销商列表",
                            parentPath: "/shop",
                            permission: ["view"],
                        },
                        component: () =>
                            import("@/views/shop/distribution/distribution_list.vue"),

                    },
                    {
                        path: "/shop/distribution/withdraw",
                        name: "shop_withdraw",
                        meta: {
                            title: "提现管理",
                            parentPath: "/shop",
                            permission: ["view"],
                        },
                        component: () =>
                            import("@/views/shop/distribution/withdraw.vue"),

                    },
                    {
                        path: "/shop/distribution/commission",
                        name: "shop_withdraw",
                        meta: {
                            title: "佣金记录",
                            parentPath: "/shop",
                            permission: ["view"],
                        },
                        component: () =>
                            import("@/views/shop/distribution/commission.vue"),
                    },
                    {
                        path: "/shop/distribution/declaration",
                        name: "shop_declaration",
                        meta: {
                            title: "客户申报",
                            parentPath: "/shop",
                            permission: ["view"],
                        },
                        component: () =>
                            import("@/views/shop/distribution/declaration.vue"),

                    },
                    {
                        path: "/shop/distribution/relatio_log",
                        name: "shop_relatio_log",
                        meta: {
                            title: "关系日志",
                            parentPath: "/shop",
                            permission: ["view"],
                        },
                        component: () =>
                            import("@/views/shop/distribution/relation_log.vue"),

                    }
                ],
            }
        ],
    },
];

export default routes;
